import useFetchLead from 'components/domain/lead/useFetchLead';

interface UseFetchBlockProps {
  blockUid?: string;
}

const leadFields = `
  uid,
  address,
  address2,
  adultCount,
  agreementSigned,
  arrivalLocalDateTime,
  assignee{bestProfile, uid},
  availablePipelineActions,
  bookedDateTimeString,
  cellPhoneNumber,
  channel{bestProfile, channel},
  affiliate,
  checkInLocalDateTime,
  checkOutLocalDateTime,
  childrenCount,
  city,
  countdown{color, countdownMinutes, countdownPercentage, visualCountdownValue},
  countryCode,
  departureLocalDateTime,
  email,
  firstName,
  hasCompletedPreArrivalForm,
  infantCount,
  lastName,
  notes,
  order{uid, currency, totalAmount, force100PercentPaymentAtReservation, securityDeposit, paymentLinkSecret, paymentLinkUrl, balance},
  petCount,
  phoneNumber,
  preferredLocale,
  property{uid},
  reviewByHost{cleanlinessRating, communicationRating, notes, overallRating, respectRulesRating, uid},
  secondaryEmail,
  source,
  state,
  status,
  wereCheckInInstructionsSent,
  zipCode,
  willHaveParty,
  willHaveVisit,
  passportID,
  passportCountryCode,
  customData{uid, name, type, usage, value{text, longText}},
  guest{registrationToken, uid},
  extraNotes,
  flightNumber,
  reasonForTrip,
  creationMetadata,
  externalBookingID,
  pinCode{pinCode, pinCodeUrl, uid}
  wasSecurityDepositReceived,
  wasSecurityDepositReturned,
  extraGuests{email, firstName, lastName, age},
  fieldsPermissionsMetadata{fieldName,metadata {editable}},
  unitUid
`;

const useFetchBlock = ({ blockUid }: UseFetchBlockProps) => {
  const { isInitialLoading, lead } = useFetchLead({
    leadUid: blockUid,
    fields: leadFields,
  });

  return {
    currentBlock: lead,
    isCurrentBlockLoading: isInitialLoading,
  };
};
export default useFetchBlock;
